export default "__VITE_ASSET__DFava8MS__"